export default class ScrollFunc {
    constructor() {
        this.$reveals = [...document.querySelectorAll('.js-scrollreveal')];
    }

    setObserve() {
        const options = { rootMargin: '0px 0px -20%' };

        for (const $reveal of this.$reveals) {
            const callback = entries => {
                for (const entry of entries) {
                    entry.isIntersecting && $reveal.classList.add('-reveal');
                }
            };

            const intersection = new IntersectionObserver(callback, options);

            intersection.observe($reveal);
        }
    }
}
